import script from "./ProductionLogTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionLogTab.vue?vue&type=script&setup=true&lang=js"

import "./ProductionLogTab.vue?vue&type=style&index=0&id=3a604850&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a604850"]])

export default __exports__